export default "__VITE_ASSET__DtlYz51K__"